export enum ShipmentLocationType {
    Pickup = 'Pickup',
    DropOff = 'DropOff',
    Rescue = 'Rescue',
    Other = 'Other',
}
